import { Button } from "@mui/material"
import MicrophoneIcon from "../../assets/icons/microphone-icon"
import RoundedCheck from "../../assets/icons/rounded-check"
import { useAssessmentStore } from "../../shared/store"
import Shell from "../shell"
import AudioPlayer from "./audio-player"

interface PreRecordingScreenProps {
    audioSrc: string
    handleStartRecording: () => void
    isRecordingError: boolean
    handleSkip: () => void
}
const PreRecordingScreen = ({
    audioSrc,
    handleStartRecording,
    isRecordingError,
    handleSkip,
}: PreRecordingScreenProps) => {
    const { assesmentQuestions } = useAssessmentStore((state) => state)
    const isVasFlow = assesmentQuestions?.mandatory
    return (
        <Shell
            footerElement={
                <>
                    {isRecordingError && (
                        <p className="text-center text-sm text-[#CB2F4B] mb-2">
                            Recording should be of minimum 30 seconds.
                            <br /> Record again.
                        </p>
                    )}
                    <div className="w-full px-4 mb-6">
                        <Button
                            onClick={handleStartRecording}
                            fullWidth
                            style={{ padding: "16px", borderRadius: "4px" }}
                        >
                            <MicrophoneIcon />
                            <p className="ml-2 font-semibold text-base text-white">
                                Record
                            </p>
                        </Button>
                        {!isVasFlow && (
                            <Button
                                onClick={handleSkip}
                                variant="text"
                                fullWidth
                                style={{ padding: "16px" }}
                            >
                                <p className="ml-2 font-semibold text-base flex items-center justify-between">
                                    Skip
                                </p>
                            </Button>
                        )}
                    </div>
                </>
            }
        >
            <div className="w-[100%] h-[100%] flex flex-col justify-between">
                <div>
                    <div className="w-[100%] mb-7">
                        <p className="text-xs mb-2">Sample Audio</p>
                        {/* Audio Player */}
                        <AudioPlayer audioSrc={audioSrc} borderRadiusTop={false} />
                    </div>
                    {/* Instructions Container */}
                    <div className="w-[100%]">
                        <p className="font-semibold text-xs text-left mb-2">
                            Instructions
                        </p>
                        <div className="p-4 border-2 border-[#D1CED4] border-solid rounded-lg  bg-[#F4F2F6]">
                            {/* Instruction */}
                            <div className="flex items-center mb-2">
                                <RoundedCheck />
                                <p className="text-xs ml-2">Record in a silent setup</p>
                            </div>
                            <div className="flex items-center mb-2">
                                <RoundedCheck />
                                <p className="text-xs ml-2">
                                    Use a good-quality microphone
                                </p>
                            </div>
                            <div className="flex items-center">
                                <RoundedCheck />
                                <p className="text-xs ml-2">
                                    Only HR can access your audio
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Shell>
    )
}
export default PreRecordingScreen
